module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/vintage-388dbabe428447dbd2295a51524d5f4d.jpg";